import React, { useEffect } from "react";

export const Navigation = () => {

  useEffect(() => {
    const navLinks = document.querySelectorAll(".navbar-nav .nav-link");
    const navbarBrand = document.querySelector(".navbar-brand");
    const navbarCollapse = document.querySelector(".navbar-collapse");

    const closeMenu = () => {
      if (!navbarCollapse.classList.contains("show")) return;

      // Aplica animação estilo Bootstrap
      navbarCollapse.classList.add("collapsing-remake");

      // Remove o show imediatamente
      navbarCollapse.classList.remove("show");

      // Remove a classe de animação após terminar a transição
      setTimeout(() => {
        navbarCollapse.classList.remove("collapsing-remake");
      }, 350);
    };

    // Links do menu
    navLinks.forEach((link) => link.addEventListener("click", closeMenu));

    // Clicar na logo também fecha
    if (navbarBrand) navbarBrand.addEventListener("click", closeMenu);

    return () => {
      navLinks.forEach((link) => link.removeEventListener("click", closeMenu));
      if (navbarBrand) navbarBrand.removeEventListener("click", closeMenu);
    };
  }, []);

  return (
    <nav id="menu" className="navbar navbar-expand-xxl fixed-top navbar-light bg-light">
      <div className="container">

        {/* Brand */}
        <a className="navbar-brand brand-custom" href="#page-top">
          <img
            src="img/NewLogo.jpg"
            alt="Clínica BarbutiAtroch"
            className="brand-logo"
          />
          <span className="brand-name">Clínica Barbuti & Atroch</span>
        </a>

        {/* Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Menu */}
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">

            <li className="nav-item"><a className="nav-link" href="#features">Especialidades</a></li>
            <li className="nav-item"><a className="nav-link" href="#about">Sobre</a></li>
            <li className="nav-item"><a className="nav-link" href="/medicos">Médicos</a></li>
            <li className="nav-item"><a className="nav-link" href="#portfolio">Galeria</a></li>
            <li className="nav-item"><a className="nav-link" href="#testimonials">Depoimentos</a></li>
            <li className="nav-item"><a className="nav-link" href="#contact">Contato</a></li>
            <li className="nav-item"><a className="nav-link" href="/calculadoras">Calculadoras</a></li>

          </ul>
        </div>
      </div>
    </nav>
  );
};
